import { requestService } from '../helpers/request.service';

export const preauthorizationService = {
    getPreauthorization,
    getHeader,
    getInvestigations,
    getDiagnostics,
    getFiles,
    getForms,
    getInvestigationsDropDown,
    getInvestigationsForms,
    savePreauthorization
}

function getPreauthorization(params) {
    return requestService.get({
        methodName: '/Preauthorization/GetPreauthorizationById',
        queryString: params
    });
}

function getHeader(params) {
    return requestService.get({
        methodName: '/Preauthorization/GetHeader',
        queryString: params
    });
}

function getInvestigations(params) {
    return requestService.get({
        methodName: '/Preauthorization/GetInvestigations',
        queryString: params
    });
}

function getDiagnostics(params) {
    return requestService.get({
        methodName: '/Preauthorization/GetDiagnostics',
        queryString: params
    });
}

function getFiles(params) {
    return requestService.get({
        methodName: '/Preauthorization/GetFiles',
        queryString: params
    });
}

function getForms(params) {
    return requestService.get({
        methodName: '/Preauthorization/GetForms',
        queryString: params
    });
}

function getInvestigationsDropDown(params) {
    return requestService.get({
        methodName: '/Preauthorization/GetInvestigationsDropDown',
        queryString: params
    });
}

function getInvestigationsForms(params) {
    return requestService.get({
        methodName: '/Preauthorization/GetInvestigationsForms',
        queryString: params
    });
}



function savePreauthorization(params) {
    return requestService.formData({
        methodName: '/Preauthorization/SavePreauthorization',
        body: params
    });
}